import WebFont from 'webfontloader';
import Promise from 'bluebird';

export default new Promise((resolve, reject) => {
    let inactives = 0;
    WebFont.load({
        active: () => {
            if (inactives)
                return;
            resolve();
        },
        inactive: () => {
            inactives++;
            reject();
        },
        fontinactive: (familyName, fvd) => {
            inactives++;
            reject();
        },
        custom: {
            families: ['PT Sans:n4,i4,n7']
        }
    });
});



// WEBPACK FOOTER //
// ./makosh/assets/fonts.js